/**
 * GETTERS
 * @type {string}
 */
// Pizza
export const GET_SELECTED_SIZE = 'category/getSelectedSize'
export const GET_SELECTED_CRUST = 'category/getSelectedCrust'
export const GET_BOTH_SELECTED_SIZE_N_CRUST = 'category/getBothSelectedSizeNCrust'

// Topping
export const GET_ADDED_EXTRA_TOPPINGS = 'topping/getAddedExtraToppings'
export const GET_REMOVED_DEFAULT_TOPPINGS = 'topping/getRemovedDefaultToppings'

export const GET_EXTRA_TOPPINGS = 'topping/getExtraToppings'
export const GET_DEFAULT_TOPPINGS = 'topping/getDefaultToppings'



/**
 * ACTIONS
 * @type {string}
 */
export const SET_ORDER_TIME = 'SET_ORDER_TIME'
export const SET_IS_VALID_ORDER_TIME = 'setIsValidOrderTime'
export const SET_SELECTED_PRODUCT = 'setSelectedProduct'
export const SET_SELECTED_CATEGORY = 'setSelectedCategory'
export const SET_SELECTED_SUB_CATEGORY = 'setSelectedSubCategory'
export const SET_SELECTED_CART = 'setSelectedCart'
export const SET_USER = 'setUser'
export const SET_LANG = 'setLang'
export const SET_CATEGORY_LIST = 'setCategoryList'
export const SET_ATTRIBUTES_LIST = 'setAttributeList'
export const SET_ATTRIBUTES_FILTER = 'setAttributeFilter'
export const SET_SELECTED_OUTLET = 'setSelectedOutlet'
export const SET_HUT_OUTLET_ID = 'setHutOutletId'
export const SET_SELECTED_HUT_OUTLET = 'setSelectedHutOutlet'
export const SET_DISPOSITION = 'setDisposition'
export const SET_PAYMENT_STATUS = 'setPaymentStatus'
export const SET_SIDEBAR_OPEN = 'setSidebarOpen'
export const SET_HOME_SIDEBAR_OPEN = 'setHomeSidebarOpen'
export const SET_TRIGGER_CHOOSING_TOPPING = 'setTriggerChoosingTopping'
export const CHECK_IS_LAND_ON_HOMEPAGE = 'checkIsLandOnHomepage'
export const GET_LAND_ON_HOMEPAGE = 'getLandOnHomepage'


// Pizza
export const SET_SELECTED_SIZE = 'category/setSelectedSize'
export const SET_SELECTED_CRUST = 'category/setSelectedCrust'
export const REMOVE_SELECTED_SIZE_N_CRUST = 'addToCart/removeSelectedSizeNCrust'


// Topping
export const SET_EXTRA_TOPPINGS = 'topping/setExtraToppings'
export const SET_DEFAULT_TOPPINGS = 'topping/setDefaultToppings'
export const UPDATE_QUANTITY_EXTRA_TOPPINGS = 'topping/updateQuantityExtraTopping'
export const UPDATE_QUANTITY_DEFAULT_TOPPINGS = 'topping/updateQuantityDefaultTopping'
export const RESET_QUANTITY_TOPPINGS = 'topping/resetQuantityToppings'

export const ADD_SELECTED_EXTRA_TOPPING = 'topping/addSelectedExtraTopping'
export const REMOVE_SELECTED_EXTRA_TOPPING = 'topping/removeSelectedExtraTopping'
export const RESET_ADDED_EXTRA_TOPPINGS = 'topping/resetAddedExtraToppings'

export const REMOVE_SELECTED_DEFAULT_TOPPING = 'topping/removeSelectedDefaultTopping'
export const RE_ADD_SELECTED_DEFAULT_TOPPING = 'topping/reAddSelectedDefaultTopping'
export const RESET_REMOVED_DEFAULT_TOPPINGS = 'topping/resetRemovedDefaultToppings'


/**
 * Half & Half
 * */
// HH's SIZE & CRUST list
export const SET_HH_SIZES = 'hhPizza/setHHSizes'
export const SET_HH_CRUSTES = 'hhPizza/setHHCrustes'

export const GET_HH_SIZES = 'hhPizza/getHHSizes'
export const GET_HH_CRUSTES = 'hhPizza/getHHCrustes'

// Selected HH's SIZE & CRUST list
export const SET_SELECTED_HH_SIZE = 'hhPizza/setSelectedSize'
export const SET_SELECTED_HH_CRUST = 'hhPizza/setSelectedCrust'

export const GET_SELECTED_HH_SIZE = 'hhPizza/getSelectedSize'
export const GET_SELECTED_HH_CRUST = 'hhPizza/getSelectedCrust'

export const GET_BOTH_SELECTED_HH_SIZE_N_CRUST = 'hhPizza/getBothSizeNCrust'
export const REMOVE_SELECTED_HH_SIZE_N_CRUST = 'addToCart/removeSelectedHHSizeNCrust'


// HH's pizza list
export const SET_HH_PIZZA_LIST = 'hhPizza/setListPizza'
export const GET_HH_PIZZA_LIST = 'hhPizza/getListPizza'


// ---------- LEFT half
export const SET_LEFT_PIZZA = 'hhPizza/setLeftPizza'
export const GET_LEFT_PIZZA = 'hhPizza/getLeftPizza'
  // **** [LEFT] toppings
  export const SET_LEFT_EXTRA_TOPPINGS = 'hhPizzaLeft/setExtraToppings'
  export const SET_LEFT_DEFAULT_TOPPINGS = 'hhPizzaLeft/setDefaultToppings'
  export const GET_LEFT_EXTRA_TOPPINGS = 'hhPizzaLeft/getExtraToppings'
  export const GET_LEFT_DEFAULT_TOPPINGS = 'hhPizzaLeft/getDefaultToppings'
  export const GET_LEFT_ADDED_EXTRA_TOPPINGS = 'hhPizzaLeft/getAddedExtraToppings'
  export const GET_LEFT_REMOVED_DEFAULT_TOPPINGS = 'hhPizzaLeft/getRemovedDefaultToppings'

  export const UPDATE_QUANTITY_LEFT_EXTRA_TOPPINGS = 'hhPizzaLeft/updateQuantityExtraTopping'
  export const UPDATE_QUANTITY_LEFT_DEFAULT_TOPPINGS = 'hhPizzaLeft/updateQuantityDefaultTopping'
  export const RESET_QUANTITY_LEFT_TOPPINGS = 'hhPizzaLeft/resetQuantityToppings'

  export const ADD_LEFT_SELECTED_EXTRA_TOPPING = 'hhPizzaLeft/addSelectedExtraTopping'
  export const REMOVE_LEFT_SELECTED_EXTRA_TOPPING = 'hhPizzaLeft/removeSelectedExtraTopping'
  export const RESET_LEFT_ADDED_EXTRA_TOPPINGS = 'hhPizzaLeft/resetAddedExtraToppings'

  export const REMOVE_LEFT_SELECTED_DEFAULT_TOPPING = 'hhPizzaLeft/removeSelectedDefaultTopping'
  export const RE_ADD_LEFT_SELECTED_DEFAULT_TOPPING = 'hhPizzaLeft/reAddSelectedDefaultTopping'
  export const RESET_LEFT_REMOVED_DEFAULT_TOPPINGS = 'hhPizzaLeft/resetRemovedDefaultToppings'

  export const RESET_LEFT_TOPPINGS = 'hhPizzaLeft/resetLeftToppings'



// ---------- RIGHT half
export const SET_RIGHT_PIZZA = 'hhPizza/setRightPizza'
export const GET_RIGHT_PIZZA = 'hhPizza/getRightPizza'

  // **** [RIGHT] toppings
export const SET_RIGHT_EXTRA_TOPPINGS = 'hhPizzaRight/setExtraToppings'
export const SET_RIGHT_DEFAULT_TOPPINGS = 'hhPizzaRight/setDefaultToppings'
export const GET_RIGHT_EXTRA_TOPPINGS = 'hhPizzaRight/getExtraToppings'
export const GET_RIGHT_DEFAULT_TOPPINGS = 'hhPizzaRight/getDefaultToppings'
export const GET_RIGHT_ADDED_EXTRA_TOPPINGS = 'hhPizzaRight/getAddedExtraToppings'
export const GET_RIGHT_REMOVED_DEFAULT_TOPPINGS = 'hhPizzaRight/getRemovedDefaultToppings'

export const UPDATE_QUANTITY_RIGHT_EXTRA_TOPPINGS = 'hhPizzaRight/updateQuantityExtraTopping'
export const UPDATE_QUANTITY_RIGHT_DEFAULT_TOPPINGS = 'hhPizzaRight/updateQuantityDefaultTopping'
export const RESET_QUANTITY_RIGHT_TOPPINGS = 'hhPizzaRight/resetQuantityToppings'

export const ADD_RIGHT_SELECTED_EXTRA_TOPPING = 'hhPizzaRight/addSelectedExtraTopping'
export const REMOVE_RIGHT_SELECTED_EXTRA_TOPPING = 'hhPizzaRight/removeSelectedExtraTopping'
export const RESET_RIGHT_ADDED_EXTRA_TOPPINGS = 'hhPizzaRight/resetAddedExtraToppings'

export const REMOVE_RIGHT_SELECTED_DEFAULT_TOPPING = 'hhPizzaRight/removeSelectedDefaultTopping'
export const RE_ADD_RIGHT_SELECTED_DEFAULT_TOPPING = 'hhPizzaRight/reAddSelectedDefaultTopping'
export const RESET_RIGHT_REMOVED_DEFAULT_TOPPINGS = 'hhPizzaRight/resetRemovedDefaultToppings'

export const RESET_RIGHT_TOPPINGS = 'hhPizzaRight/resetRightToppings'

export const SET_SHOW_MODAL_TAKE_AWAY_LESS = 'setShowModalTakeAwayLess'

export const SET_HUT_REWARD = 'setHutReward'
export const GET_HUT_REWARD = 'getHutReward'
export const SET_MAINTAINANCE_HUT_REWARD = 'setMaintainanceHutReward'
export const GET_MAINTAINANCE_HUT_REWARD = 'getMaintainanceHutReward'
export const SET_SLICES_REWARD = 'setSlicesReward'
export const GET_SLICES_REWARD = 'getSlicesReward'



// WEBPACK FOOTER //
// ./src/store/types.js